(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!Shopify.designMode) return;

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;

    var carousel = section.querySelector('.featured-collection__carousel-grid-items');
    if (!carousel) return;

    if (window.Flickity && !carousel.classList.contains('flickity-enabled')) {
      new Flickity(carousel, JSON.parse(carousel.dataset.flickity));
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-video-slider]').forEach(slider => {
    const track = slider.querySelector('.video-slider-track');
    const slides = slider.querySelectorAll('.video-slide');
    const dots = slider.querySelectorAll('.video-slider-dot');

    let index = 0;
    let interval = null;
    const autoplay = slider.dataset.autoplay === 'true';
    const speed = parseInt(slider.dataset.speed, 10) || 4000;

    function goToSlide(i) {
      if (!slides[i]) return;

      track.scrollTo({
        left: slides[i].offsetLeft,
        behavior: 'smooth'
      });

      dots.forEach(d => d.classList.remove('is-active'));
      if (dots[i]) dots[i].classList.add('is-active');

      // Pause all videos except active
     slides.forEach(slide => {
      const video = slide.querySelector('video');
      if (video) {
        video.currentTime = 0;
      }
    });

      index = i;
    }

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        goToSlide(parseInt(dot.dataset.slide, 10));
        stopAutoplay();
      });
    });

    function startAutoplay() {
      if (!autoplay) return;
      interval = setInterval(() => {
        goToSlide((index + 1) % slides.length);
      }, speed);
    }

    function stopAutoplay() {
      if (interval) clearInterval(interval);
    }

    goToSlide(0);
    startAutoplay();
  });
});

  } catch(e) { console.error(e); }
})();
})();
